import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiPost, apiGet, apiDelete, apiPut } from "../../api/index";
import moment from "moment-timezone";
import {
  urlFilterProductionOrderSapSecured,
  urlNotifyProductionOrderSapSecured,
} from "../../api/urls";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";
  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.idOrderSap !== undefined)
      filter += "&idOrderSap=" + filters.idOrderSap;
    if (filters.sapQuantity !== undefined)
      filter += "&sapQuantity=" + filters.sapQuantity;
    if (filters.sapDateStart) {
      const sapDateStart = moment(filters.sapDateStart);
      filter += "&sapDateStart=" + sapDateStart.valueOf();
    }
    if (filters.status !== undefined) filter += "&status=" + filters.status;
    if (filters.showNotificated !== undefined)
      filter += "&showNotificated=" + filters.showNotificated;
  }
  if (sort) filter += "&sort=" + sort;

  return filter;
};

export const getProductionOrderSap = createAction(
  "GET_PRODUCTION_ORDER_SAP",
  (param) => apiGet(urlFilterProductionOrderSapSecured, param, true)()
);

/**
 * Filter list orders.
 */
export const filterProductionOrderSap = createAction(
  "FILTER_PRODUCTION_ORDER_SAP",
  (filter, param) =>
    apiGet(
      urlFilterProductionOrderSapSecured + generateFilterQuery(filter),
      param,
      true
    )()
);

/**
 * Update productionOrderSap by uuid
 */
export const updateProductionOrderSap = createAction(
  "UPDATE_PRODUCTION_ORDER_SAP",
  (param, data) =>
    apiPut(urlFilterProductionOrderSapSecured, data, param, true)()
);

/**
 * Update productionOrderSap by uuid
 */
export const notifyOrder = createAction(
  "NOTIFY_PRODUCTION_ORDER_SAP",
  (param) => apiPost(urlNotifyProductionOrderSapSecured, {}, param, true)()
);
